import React, { useEffect, useState, useRef } from 'react';
import { Box, Grid2 } from '@mui/material';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import type { Consults } from './shared/consults';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomChip from '@ui-components/Chip/CustomChip';
import CustomSwitch from '@ui-components/Switch/CustomSwitch';
import CustomTabs from '@ui-components/Tabs/CustomTabs';
import './myconsults.css';
import { CallStatusEnum } from './shared/CallStatusEnum';
import CustomCheckBoxGroup from '@ui-components/CheckBoxGroup/CustomCheckBoxGroup';
import CustomTextField from '@ui-components/TextField/CustomTextField';
import CustomTabPanel from '@ui-components/Tabs/CustomTabPanel';
import CustomMenu from '@ui-components/Menu/CustomMenu';
import CustomMenuList from '@ui-components/Menu/CustomMenuList';
import CustomIconButton from '@ui-components/IconButton/CustomIconButton';
import CustomBadge from '@ui-components/Badge/CustomBadge';
//Icon
import Searchicon from '@assets/images/search.svg';
import FilterIcon from '@assets/images/Filter.svg';
import CustomLink from '@ui-components/Link/CustomLink';
import CustomDivider from '@ui-components/Divider/CustomDivider';
import FilterCheckbox from '../components/FilterCheckbox';

//Hooks
import {
  useGetTodaysConsults,
  useGetPastsConsults,
  useGetFacilityFilter,
  useAcceptConsult,
} from '../../API/hooks/consultsHook';
import type {
  TodaysConsults,
  PastsConsults,
  IndeterminateCheckboxProps,
  ConsultsResponse,
  AcceptResponse,
} from '../../API/services/consultsService';

import WarningDialog from '../components/AcceptWarningDialog';
import CustomSnackbar from '@ui-components/Snackbar/CustomSnackbar';
import ConsultListRender from './ConsultListRender';

type MyConsultsProps = {
  consults: Consults[];
};

const MyConsults: React.FC<MyConsultsProps> = () => {
  const userId = Number.parseInt(localStorage.getItem('userId') ?? '0');
  console.log('consults-UserId', userId);

  const { facilityFilter } = useGetFacilityFilter(userId);

  const [isChecked, setIsChecked] = useState(false);

  const [isShowAllChecked, setIsShowAllChecked] = useState(false);

  const [statusApplyButtonClicked, setStatusApplyButtonClicked] =
    useState<boolean>(false);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [clearFilter, setClearFilter] = useState(false);
  const [facilityCount, setFacilityCount] = useState(0);
  const checkedIdRef = useRef<IndeterminateCheckboxProps[]>([]);
  const [searchHospitalKey, setSearchHospitalKey] = useState<string>('');
  const [appliedStatuses, setAppliedStatuses] = useState<string[]>([]);
  const checkedIdsStatusApply = useRef<string[]>([]);
  const [appliedFacilityCount, setAppliedFacilityCount] = useState<number>(0);

  const statusApplyClicked = useRef<boolean>(false);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (statusApplyClicked.current) {
      setSelectedStatuses((prevSelectedStatuses) => prevSelectedStatuses);
      statusApplyClicked.current = false;
    } else {
      setSelectedStatuses(checkedIdsStatusApply.current);
    }
  };
  const handleClickFacilities = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElFacilities(event.currentTarget);
    setOpenFacilities(true);
    let count = 0;

    checkedIdRef.current?.forEach((facility) => {
      if (
        facility.checkFacility ||
        facility.hospitals.some((hospital) => hospital.checked)
      ) {
        count++;
      }
    });

    setFacilityCount(count);
  };

  const handleCloseFacilities = () => {
    setAnchorElFacilities(null);
    setOpenFacilities(false);

    if (checkedIdRef.current.length === 0) {
      setFacilityCount(0);
    }

    setSearchHospitalKey('');
  };

  const consultStatus = [
    { label: 'New', value: 'New' },
    { label: 'Call Started', value: 'Call Started' },
    { label: 'In Progress', value: 'In Progress' },
    { label: 'Call Completed', value: 'Call Completed' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Canceled', value: 'Canceled' },
  ];
  const pastStatus = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Canceled', value: 'Canceled' },
  ];

  const handleHospitalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchHospitalKey(event.target.value);
  };

  const tabItems = [
    { label: 'Today’s Consults', value: 0 },
    { label: 'Past Consults', value: 1 },
  ];

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [anchorElFacilities, setAnchorElFacilities] =
    useState<null | HTMLElement>(null);
  const [openFacilities, setOpenFacilities] = useState(false);

  const { todaysConsults, refetch, isPending } = useGetTodaysConsults(userId);
  const [todaysConsultList, setTodaysConsultList] = useState<TodaysConsults>();

  const onShowAllChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsShowAllChecked(event.target.checked);
  };

  const lastSelectedTabIndex =
    localStorage.getItem('lastSelectedTabIndex') ?? '0';
  const [activeTab, setActiveTab] = useState<number | string>(
    Number.parseInt(lastSelectedTabIndex)
  );

  const [pastsConsultList, setPastsConsultList] = useState<PastsConsults>();
  const { pastsConsults, isPending: pastsPending } =
    useGetPastsConsults(userId);

  const [searchConsults, setSearchConsults] = useState<string>('');

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: number | string
  ) => {
    localStorage.setItem('lastSelectedTabIndex', newValue.toString());
    setSearchConsults('');
    setActiveTab(newValue);

    setSelectedStatuses([]);
    checkedIdRef.current = [];
    setClearFilter(true);
    setIsChecked(false);
    setPastsConsultList(pastsConsults);
    setIsShowAllChecked(false);
    setAppliedStatuses([]);
    setAppliedFacilityCount(0);
  };

  useEffect(() => {
    if (activeTab === 1) {
      searchAndFilterPastConsults(selectedStatuses, checkedIdRef.current);
    } else if (activeTab === 0) {
      searchAndFilterTodaysConsults(
        selectedStatuses,
        checkedIdRef.current,
        isChecked
      );
    }
  }, [activeTab, searchConsults, pastsConsults, todaysConsults]);

  const handleStorageUpdate = () => {
    const lastSelectedTabIndex =
      localStorage.getItem('lastSelectedTabIndex') ?? '0';
    setActiveTab(Number.parseInt(lastSelectedTabIndex));

    setSearchConsults('');

    setSelectedStatuses([]);
    checkedIdRef.current = [];
    setClearFilter(true);
    setIsChecked(false);
    setIsShowAllChecked(false);
    setAppliedStatuses([]);
    setAppliedFacilityCount(0);
    searchAndFilterTodaysConsults([], [], false);
  };

  useEffect(() => {
    document.addEventListener('tabchange', handleStorageUpdate);
    return () => {
      globalThis.removeEventListener('tabchange', handleStorageUpdate);
    };
  }, []);

  const handleSearch = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSearchConsults(event.target.value);
  };

  const searchTodaysConsults = (
    filteredConsults: TodaysConsults
  ): TodaysConsults => {
    if (searchConsults.trim().length > 0) {
      const searchTerms = searchConsults.toLowerCase().split(' ');

      const searchMyConsults =
        filteredConsults?.myConsults.filter((consult) => {
          const facilityName = consult.facilityName?.toLowerCase() ?? '';
          const partnerName = consult.partnerName?.toLowerCase() ?? '';
          const patientFirstName =
            consult.patientFirstName?.toLowerCase() ?? '';
          const patientLastName = consult.patientLastName?.toLowerCase() ?? '';
          const mrn = consult.mrn?.toLowerCase() ?? '';
          const fullName = `${patientFirstName} ${patientLastName}`;

          return (
            facilityName.includes(searchTerms.join(' ')) ||
            partnerName.includes(searchTerms.join(' ')) ||
            searchTerms.every(
              (term) =>
                patientFirstName.includes(term) ||
                patientLastName.includes(term)
            ) ||
            fullName.includes(searchTerms.join(' ')) ||
            mrn.includes(searchTerms.join(' '))
          );
        }) ?? [];

      const searchAvailableConsults =
        filteredConsults?.availableConsults.filter((consult) => {
          const facilityName = consult.facilityName?.toLowerCase() ?? '';
          const partnerName = consult.partnerName?.toLowerCase() ?? '';
          const patientFirstName =
            consult.patientFirstName?.toLowerCase() ?? '';
          const patientLastName = consult.patientLastName?.toLowerCase() ?? '';
          const mrn = consult.mrn?.toLowerCase() ?? '';
          const fullName = `${patientFirstName} ${patientLastName}`;

          return (
            facilityName.includes(searchTerms.join(' ')) ||
            partnerName.includes(searchTerms.join(' ')) ||
            searchTerms.every(
              (term) =>
                patientFirstName.includes(term) ||
                patientLastName.includes(term)
            ) ||
            fullName.includes(searchTerms.join(' ')) ||
            mrn.includes(searchTerms.join(' '))
          );
        }) ?? [];

      const searchAssignedConsults =
        filteredConsults?.assignedConsults.filter((consult) => {
          const facilityName = consult.facilityName?.toLowerCase() ?? '';
          const partnerName = consult.partnerName?.toLowerCase() ?? '';
          const patientFirstName =
            consult.patientFirstName?.toLowerCase() ?? '';
          const patientLastName = consult.patientLastName?.toLowerCase() ?? '';
          const mrn = consult.mrn?.toLowerCase() ?? '';
          const fullName = `${patientFirstName} ${patientLastName}`;

          return (
            facilityName.includes(searchTerms.join(' ')) ||
            partnerName.includes(searchTerms.join(' ')) ||
            searchTerms.every(
              (term) =>
                patientFirstName.includes(term) ||
                patientLastName.includes(term)
            ) ||
            fullName.includes(searchTerms.join(' ')) ||
            mrn.includes(searchTerms.join(' '))
          );
        }) ?? [];

      return {
        myConsults: searchMyConsults,
        assignedConsults: searchAssignedConsults,
        availableConsults: searchAvailableConsults,
      } as TodaysConsults;
    } else {
      return structuredClone(todaysConsults) as TodaysConsults;
    }
  };

  const searchPastConsults = (): PastsConsults => {
    if (searchConsults.trim().length > 0) {
      const searchTerms = searchConsults.toLowerCase().split(' ');

      const searchMypastConsults =
        pastsConsults?.myPastConsults.filter((consult) => {
          const facilityName = consult.facilityName?.toLowerCase() ?? '';
          const partnerName = consult.partnerName?.toLowerCase() ?? '';
          const patientFirstName =
            consult.patientFirstName?.toLowerCase() ?? '';
          const patientLastName = consult.patientLastName?.toLowerCase() ?? '';
          const mrn = consult.mrn?.toLowerCase() ?? '';
          const fullName = `${patientFirstName} ${patientLastName}`;

          return (
            facilityName.includes(searchTerms.join(' ')) ||
            partnerName.includes(searchTerms.join(' ')) ||
            searchTerms.every(
              (term) =>
                patientFirstName.includes(term) ||
                patientLastName.includes(term)
            ) ||
            fullName.includes(searchTerms.join(' ')) ||
            mrn.includes(searchTerms.join(' '))
          );
        }) ?? [];

      const searchAssignedPastConsults =
        pastsConsults?.assignedPastConsults.filter((consult) => {
          const facilityName = consult.facilityName?.toLowerCase() ?? '';
          const partnerName = consult.partnerName?.toLowerCase() ?? '';
          const patientFirstName =
            consult.patientFirstName?.toLowerCase() ?? '';
          const patientLastName = consult.patientLastName?.toLowerCase() ?? '';
          const mrn = consult.mrn?.toLowerCase() ?? '';
          const fullName = `${patientFirstName} ${patientLastName}`;

          return (
            facilityName.includes(searchTerms.join(' ')) ||
            partnerName.includes(searchTerms.join(' ')) ||
            searchTerms.every(
              (term) =>
                patientFirstName.includes(term) ||
                patientLastName.includes(term)
            ) ||
            fullName.includes(searchTerms.join(' ')) ||
            mrn.includes(searchTerms.join(' '))
          );
        }) ?? [];

      return {
        myPastConsults: searchMypastConsults,
        assignedPastConsults: searchAssignedPastConsults,
      } as PastsConsults;
    } else {
      if (pastsConsults) {
        setPastsConsultList(structuredClone(pastsConsults));
      }
      return structuredClone(pastsConsults) as PastsConsults;
    }
  };

  const filterTodaysConsultsWithStatus = (
    consults: TodaysConsults,
    statuses: string[]
  ): TodaysConsults => {
    const filteredMyConsults =
      consults?.myConsults.filter((consult) =>
        statuses.some(
          (status) =>
            consult.sessionStatus?.toLowerCase() === status.toLowerCase()
        )
      ) ?? [];
    const filteredAssignedConsults =
      consults?.assignedConsults.filter((consult) =>
        statuses.some(
          (status) =>
            consult.sessionStatus?.toLowerCase() === status.toLowerCase()
        )
      ) ?? [];

    const filteredAvailableConsults =
      consults?.availableConsults.filter((consult) =>
        statuses.some(
          (status) =>
            consult.sessionStatus?.toLowerCase() === status.toLowerCase()
        )
      ) ?? [];

    return {
      myConsults: filteredMyConsults,
      assignedConsults: filteredAssignedConsults,
      availableConsults: filteredAvailableConsults,
    } as TodaysConsults;
  };

  const filterPastConsultsWithStatus = (
    consults: PastsConsults,
    statuses: string[]
  ): PastsConsults => {
    const filteredMyPastConsults =
      consults?.myPastConsults.filter((consult) =>
        statuses.some(
          (status) =>
            consult.sessionStatus?.toLowerCase() === status.toLowerCase()
        )
      ) ?? [];
    const filteredPastAssignedConsults =
      consults?.assignedPastConsults.filter((consult) =>
        statuses.some(
          (status) =>
            consult.sessionStatus?.toLowerCase() === status.toLowerCase()
        )
      ) ?? [];

    return {
      myPastConsults: filteredMyPastConsults,
      assignedPastConsults: filteredPastAssignedConsults,
    } as PastsConsults;
  };
  const filterMyConsultsList = (
    consults: TodaysConsults,
    hospitalName: string
  ) => {
    return (
      consults?.myConsults.filter(
        (secondItem) => secondItem.facilityName === hospitalName
      ) ?? []
    );
  };
  const filterAvailableConsultsList = (
    consults: TodaysConsults,
    hospitalName: string
  ) => {
    return (
      consults?.availableConsults.filter(
        (secondItem) => secondItem.facilityName === hospitalName
      ) ?? []
    );
  };
  const filterAssignedConsultsList = (
    consults: TodaysConsults,
    hospitalName: string
  ) => {
    return (
      consults?.assignedConsults.filter(
        (secondItem) => secondItem.facilityName === hospitalName
      ) ?? []
    );
  };
  const filterTodaysConsultsWithFacility = (
    consults: TodaysConsults,
    ids: IndeterminateCheckboxProps[]
  ): TodaysConsults => {
    const filtermyConsults: ConsultsResponse[] = [];
    const filteravailableConsults: ConsultsResponse[] = [];
    const filterassignedConsults: ConsultsResponse[] = [];
    if (facilityCount > 0) {
      ids.forEach((firstItem) => {
        if (firstItem.checkFacility) {
          const facilityName = firstItem.faciltyName;

          const matchedObjects =
            consults?.myConsults.filter(
              (secondItem) => secondItem.partnerName === facilityName
            ) ?? [];

          filtermyConsults.push(...matchedObjects);

          const availableObjects =
            consults?.availableConsults.filter(
              (secondItem) => secondItem.partnerName === facilityName
            ) ?? [];

          filteravailableConsults.push(...availableObjects);
          const assignObjects =
            consults?.assignedConsults.filter(
              (secondItem) => secondItem.partnerName === facilityName
            ) ?? [];

          filterassignedConsults.push(...assignObjects);
        } else if (firstItem.checkInderterminate) {
          firstItem.hospitals.forEach((element) => {
            const hospitalName = element.name;
            const hospitalChecked = element.checked;
            if (hospitalChecked) {
              const matchedObjects = filterMyConsultsList(
                consults,
                hospitalName
              );

              filtermyConsults.push(...matchedObjects);

              const availableObjects = filterAvailableConsultsList(
                consults,
                hospitalName
              );

              filteravailableConsults.push(...availableObjects);
              const assignObjects = filterAssignedConsultsList(
                consults,
                hospitalName
              );

              filterassignedConsults.push(...assignObjects);
            }
          });
        }
      });

      return {
        myConsults: filtermyConsults,
        assignedConsults: filterassignedConsults,
        availableConsults: filteravailableConsults,
      } as TodaysConsults;
    } else {
      return {
        myConsults: consults?.myConsults,
        assignedConsults: consults?.assignedConsults,
        availableConsults: consults?.availableConsults,
      };
    }
  };
  const filterPastConsultsList = (
    consults: PastsConsults,
    facilityName: string
  ) => {
    return (
      consults?.myPastConsults.filter(
        (secondItem) => secondItem.partnerName === facilityName
      ) ?? []
    );
  };
  const filterassignedPastConsultsList = (
    consults: PastsConsults,
    facilityName: string
  ) => {
    return (
      consults?.assignedPastConsults.filter(
        (secondItem) => secondItem.partnerName === facilityName
      ) ?? []
    );
  };
  const filterPastConsultsHospitalList = (
    consults: PastsConsults,
    hospitalName: string
  ) => {
    return (
      consults?.myPastConsults.filter(
        (secondItem) => secondItem.facilityName === hospitalName
      ) ?? []
    );
  };
  const filterassignedPastConsultsHospitalList = (
    consults: PastsConsults,
    hospitalName: string
  ) => {
    return (
      consults?.assignedPastConsults.filter(
        (secondItem) => secondItem.facilityName === hospitalName
      ) ?? []
    );
  };
  const filterPastConsultsWithFacility = (
    consults: PastsConsults,
    ids: IndeterminateCheckboxProps[]
  ): PastsConsults => {
    const filtermyPastConsults: ConsultsResponse[] = [];
    const filterAssignedPastConsults: ConsultsResponse[] = [];
    ids.forEach((firstItem) => {
      if (firstItem.checkFacility) {
        const facilityName = firstItem.faciltyName;
        const matchedObjects = filterPastConsultsList(consults, facilityName);

        filtermyPastConsults.push(...matchedObjects);

        const availableObjects = filterassignedPastConsultsList(
          consults,
          facilityName
        );

        filterAssignedPastConsults.push(...availableObjects);
      } else if (firstItem.checkInderterminate) {
        firstItem.hospitals.forEach((element) => {
          const hospitalName = element.name;
          const hospitalChecked = element.checked;
          if (hospitalChecked) {
            const matchedObjects = filterPastConsultsHospitalList(
              consults,
              hospitalName
            );

            filtermyPastConsults.push(...matchedObjects);

            const availableObjects = filterassignedPastConsultsHospitalList(
              consults,
              hospitalName
            );

            filterAssignedPastConsults.push(...availableObjects);
          }
        });
      }
    });

    return {
      myPastConsults: filtermyPastConsults,
      assignedPastConsults: filterAssignedPastConsults,
    } as PastsConsults;
  };

  const getFacilityCount = (data: IndeterminateCheckboxProps[]) => {
    let count = 0;
    data.forEach((facility) => {
      if (
        facility.checkFacility ||
        facility.hospitals.some((hospital) => hospital.checked)
      ) {
        count++;
      }
    });

    setFacilityCount(count);
  };

  const { mutate: accept } = useAcceptConsult(userId, refetch);

  const [alertAccept, setAlertAccept] = useState<{
    message: string;
    title: string;
  } | null>(null);

  const [openToast, setOpenToast] = useState(false);
  const [message, setMessage] = useState('');

  const handleAccept = (userId: number, caseId: number) => {
    accept(
      { userId, caseId },
      {
        onSuccess: (data: AcceptResponse) => {
          if (data?.code === 200) {
            setMessage('Consult accepted successfully');
            setOpenToast(true);
            setTimeout(() => {
              setOpenToast(false);
            }, 5000);
            //Scrolling to top of the page
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          } else if (data?.code === 400) {
            setAlertAccept({
              title: 'Alert',
              message: `This consult request has already been assigned to Dr. ${data.providerFirstName} ${data.providerLastName}`,
            });
          }
        },
        onError: (error: { status: number; message?: string }) => {
          if (error.status === 409) {
            setAlertAccept({
              title: 'Alert',
              message:
                error.message ??
                'You have reached the maximum number of active consults',
            });
          } else {
            setAlertAccept({
              title: 'Error',
              message: 'An error occurred while accepting the consult',
            });
          }
        },
      }
    );
  };

  const searchAndFilterTodaysConsults = (
    statuses: string[],
    ids: IndeterminateCheckboxProps[],
    isCompletedChecked: boolean
  ) => {
    if (!todaysConsults) {
      return;
    }
    let filteredConsults: TodaysConsults;

    if (isCompletedChecked) {
      filteredConsults = structuredClone(todaysConsults);
    } else {
      const filteredConsultsTemp = structuredClone(todaysConsults);
      const filteredMyConsults =
        filteredConsultsTemp?.myConsults?.filter(
          (consult) =>
            consult.sessionStatus?.toLowerCase() !== CallStatusEnum.Completed &&
            consult.sessionStatus?.toLowerCase() !== CallStatusEnum.Cancelled &&
            consult.sessionStatus?.toLowerCase() !== CallStatusEnum.Abandoned
        ) ?? [];
      filteredConsultsTemp.myConsults = filteredMyConsults;
      filteredConsults = filteredConsultsTemp;
    }

    if (searchConsults !== '') {
      filteredConsults = searchTodaysConsults(filteredConsults);
    }

    if (statuses.length > 0) {
      filteredConsults = filterTodaysConsultsWithStatus(
        filteredConsults,
        statuses
      );
    }

    if (ids.length > 0) {
      filteredConsults = filterTodaysConsultsWithFacility(
        filteredConsults,
        ids
      );
    }

    setTodaysConsultList(filteredConsults);
  };

  const searchAndFilterPastConsults = (
    statuses: string[],
    ids: IndeterminateCheckboxProps[]
  ) => {
    if (!pastsConsults) {
      return;
    }
    let filteredPastConsult: PastsConsults;
    if (searchConsults.trim().length > 0) {
      filteredPastConsult = searchPastConsults();
    } else {
      filteredPastConsult = structuredClone(pastsConsults);
    }

    if (statuses.length > 0) {
      filteredPastConsult = filterPastConsultsWithStatus(
        filteredPastConsult,
        statuses
      );
    }

    if (ids.length > 0) {
      filteredPastConsult = filterPastConsultsWithFacility(
        filteredPastConsult,
        ids
      );
    }

    setPastsConsultList(filteredPastConsult);
  };

  const getAriaControls = (isOpen: boolean) =>
    isOpen ? 'fade-menu' : undefined;

  const getAriaControlsFacility = (isOpen: boolean) =>
    isOpen ? 'fade-menu-facilities' : undefined;

  const getAriaExpand = (isOpen: boolean) => (isOpen ? 'true' : undefined);

  const getStatusBasedOnTab = (tabIndex: string | number) => {
    return tabIndex === 0 ? consultStatus : pastStatus;
  };

  const getFacilityCountDisplay = (shouldClear: boolean, count: number) => {
    if (shouldClear) return 0;
    return count;
  };

  return (
    <Box>
      <Box>
        <Grid2 container>
          <CustomSnackbar
            id="Consult-Accepted-Success"
            successOrError={'success'}
            open={openToast}
            handleClose={() => setOpenToast(false)}
            toastrMessage={message}
          />
          <Grid2 size={{ xs: 6 }}>
            <Box>
              <Grid2 container>
                <Box className="flex">
                  <Box>
                    <CustomTabs
                      id="tabs"
                      tabs={tabItems}
                      value={activeTab}
                      onChange={handleTabChange}
                      indicatorColor="primary"
                      textColor="primary"
                      orientation="horizontal"
                    />
                  </Box>
                  <Box className="flex mt-14">
                    <CustomSwitch
                      className="ml-8"
                      id="idShowAll"
                      checked={isShowAllChecked}
                      onChange={onShowAllChange}
                      color="primary"
                      labelPlacement="start"
                      label="Show All"
                    />
                  </Box>
                </Box>
              </Grid2>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <Box className="flex float-right">
              <Box>
                <CustomTextField
                  id="txt-search-consults"
                  name="search-consults-qler"
                  placeholder="Search Consults"
                  size="small"
                  type="text"
                  value={searchConsults}
                  onChange={handleSearch}
                  isAnimated={true}
                  startAdornment={
                    <CustomIconButton
                      id="search"
                      size="small"
                      icon={<Searchicon />}
                    />
                  }
                />
              </Box>
              <Box className="ml-16 mr-16">
                {statusApplyButtonClicked ? (
                  <CustomBadge
                    id="demo-badge"
                    badgeContent={appliedStatuses.length}
                    color="error"
                    max={600}
                  >
                    <CustomChip
                      aria-controls={getAriaControls(open)}
                      aria-haspopup="true"
                      aria-expanded={getAriaExpand(open)}
                      onClick={(e) => {
                        handleClick(e);
                      }}
                      className="box-border2"
                      id="demo-chip"
                      label="Status"
                      variant="outlined"
                      icon={<FilterIcon />}
                      iconPosition="left"
                    />
                  </CustomBadge>
                ) : (
                  <CustomChip
                    aria-controls={getAriaControls(open)}
                    aria-haspopup="true"
                    aria-expanded={getAriaExpand(open)}
                    onClick={(e) => {
                      handleClick(e);
                    }}
                    className="box-border2"
                    id="demo-chip"
                    label="Status"
                    variant="outlined"
                    icon={<FilterIcon />}
                    iconPosition="left"
                  />
                )}
                <CustomMenu
                  id="conditional-menu"
                  anchorEl={anchorEl ?? document.body}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  className="mt-4"
                >
                  <Box className="status-filter-width p-20">
                    <Box className="flex-justify-space-between align-items-center">
                      <CustomTypography id="small-font" variant="subtitle1">
                        Status&nbsp;({selectedStatuses.length})
                      </CustomTypography>
                      <CustomLink
                        className="float-right"
                        color="primary"
                        underline="hover"
                        onClick={() => {
                          handleClose();
                          setSelectedStatuses([]);
                          setStatusApplyButtonClicked(false);
                          setAppliedStatuses([]);
                          if (activeTab === 0) {
                            searchAndFilterTodaysConsults(
                              [],
                              checkedIdRef.current,
                              isChecked
                            );
                          } else {
                            searchAndFilterPastConsults(
                              [],
                              checkedIdRef.current
                            );
                          }
                        }}
                        id="Status-Clear-Filter"
                      >
                        Clear Filter
                      </CustomLink>
                    </Box>
                    <Box className="pt-12 pb-10">
                      <CustomDivider />
                    </Box>
                    <CustomMenuList>
                      <CustomTypography
                        id="small-font"
                        variant="h6"
                        className="pb-12"
                      >
                        <CustomCheckBoxGroup
                          id="cbGroup"
                          options={getStatusBasedOnTab(activeTab)}
                          selectedValues={selectedStatuses}
                          onChange={setSelectedStatuses}
                          color="primary"
                          size="small"
                        />
                      </CustomTypography>
                    </CustomMenuList>
                    <Box>
                      <CustomButton
                        id="btnLarge"
                        variant="contained"
                        className="button-width"
                        onClick={() => {
                          setStatusApplyButtonClicked(true);
                          statusApplyClicked.current = true;
                          checkedIdsStatusApply.current = selectedStatuses;
                          setAppliedStatuses([...selectedStatuses]);
                          handleClose();
                          checkedIdsStatusApply.current = selectedStatuses;
                          if (activeTab === 0) {
                            searchAndFilterTodaysConsults(
                              selectedStatuses,
                              checkedIdRef.current,
                              isChecked
                            );
                          } else {
                            searchAndFilterPastConsults(
                              selectedStatuses,
                              checkedIdRef.current
                            );
                          }
                        }}
                      >
                        Apply
                      </CustomButton>
                    </Box>
                  </Box>
                </CustomMenu>
              </Box>
              <Box>
                {clearFilter ? (
                  <CustomChip
                    aria-controls={getAriaControlsFacility(openFacilities)}
                    aria-haspopup="true"
                    aria-expanded={getAriaExpand(openFacilities)}
                    onClick={(e) => {
                      handleClickFacilities(e);
                    }}
                    className="box-border2"
                    id="demo-chip-facilities"
                    label="Facilities"
                    icon={<FilterIcon />}
                    iconPosition="left"
                    variant="outlined"
                  />
                ) : (
                  <CustomBadge
                    id="demo-badge"
                    badgeContent={appliedFacilityCount}
                    color="error"
                    max={600}
                  >
                    <CustomChip
                      aria-controls={getAriaControlsFacility(openFacilities)}
                      aria-haspopup="true"
                      aria-expanded={getAriaExpand(openFacilities)}
                      onClick={(e) => {
                        handleClickFacilities(e);
                      }}
                      className="box-border2"
                      id="demo-chip-facilities"
                      label="Facilities"
                      icon={<FilterIcon />}
                      iconPosition="left"
                      variant="outlined"
                    />
                  </CustomBadge>
                )}
                <CustomMenu
                  id="hospitallistmenu-menu"
                  anchorEl={anchorElFacilities ?? document.body}
                  open={openFacilities}
                  onClose={handleCloseFacilities}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  className="mt-4"
                >
                  <Box className="mr-20 ml-20 mt-16 mb-16">
                    <Box className="flex-justify-space-between align-items-center">
                      <CustomTypography
                        id="small-font"
                        variant="subtitle1"
                        className="pr-24"
                      >
                        Facilities&nbsp;(
                        {getFacilityCountDisplay(clearFilter, facilityCount)})
                      </CustomTypography>
                      <CustomLink
                        className="float-right"
                        color="primary"
                        underline="hover"
                        onClick={() => {
                          handleCloseFacilities();
                          setClearFilter(true);
                          checkedIdRef.current = [];
                          setAppliedFacilityCount(0);
                          if (activeTab === 0) {
                            searchAndFilterTodaysConsults(
                              selectedStatuses,
                              [],
                              isChecked
                            );
                          } else {
                            searchAndFilterPastConsults(selectedStatuses, []);
                          }
                        }}
                        id="Facilities-Clear-Filter"
                      >
                        Clear Filter
                      </CustomLink>
                    </Box>
                    <Box className="pt-18">
                      <CustomDivider variant="fullWidth" />
                    </Box>
                    {facilityFilter && (
                      <Box className="pt-16">
                        <CustomTextField
                          id="txtSearchHospitalName"
                          placeholder="Search"
                          size="small"
                          type="text"
                          className="searchHeight"
                          value={searchHospitalKey}
                          onChange={handleHospitalChange}
                        />
                      </Box>
                    )}
                  </Box>
                  <CustomMenuList>
                    {facilityFilter && (
                      <FilterCheckbox
                        searchText={searchHospitalKey}
                        applyButtonCliked={(checkedIdsData) => {
                          checkedIdRef.current = checkedIdsData;
                          setClearFilter(false);
                          handleCloseFacilities();
                          setAppliedFacilityCount(facilityCount);
                          if (activeTab === 0) {
                            searchAndFilterTodaysConsults(
                              selectedStatuses,
                              checkedIdRef.current,
                              isChecked
                            );
                          } else {
                            searchAndFilterPastConsults(
                              selectedStatuses,
                              checkedIdRef.current
                            );
                          }
                        }}
                        healthSystems={facilityFilter.healthSystems}
                        clearFilter={clearFilter}
                        getFacilityCount={getFacilityCount}
                        storedPreviousValues={checkedIdRef.current}
                      />
                    )}
                  </CustomMenuList>
                </CustomMenu>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Box>

      <CustomTabPanel value={activeTab} index={0}>
        <Box>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <Box className="text-align-left flex">
                <CustomTypography
                  id="title-myconsults"
                  variant="h6"
                  color="textDisabled"
                >
                  My Consults&nbsp;({todaysConsultList?.myConsults.length ?? 0})
                </CustomTypography>
                <CustomSwitch
                  className="ml-8"
                  id="idShowCompleted"
                  checked={isChecked}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setIsChecked(event.target.checked);
                    searchAndFilterTodaysConsults(
                      selectedStatuses,
                      checkedIdRef.current,
                      event.target.checked
                    );
                  }}
                  color="primary"
                  size="medium"
                  labelPlacement="start"
                  label="Show Completed"
                />
              </Box>
            </Grid2>

            <ConsultListRender
              consults={todaysConsultList?.myConsults ?? []}
              emptyMessage="No My Consults"
              loading={isPending || !todaysConsultList}
            />
          </Grid2>
        </Box>

        <Box className="pt-24">
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <Box className="text-align-left">
                <CustomTypography
                  id="title-myconsults"
                  variant="h6"
                  color="textDisabled"
                >
                  Available Consults&nbsp;(
                  {todaysConsultList?.availableConsults?.length ?? 0})
                </CustomTypography>
              </Box>
            </Grid2>

            <ConsultListRender
              consults={todaysConsultList?.availableConsults ?? []}
              emptyMessage="No Available Consults"
              loading={isPending || !todaysConsultList}
              assigned={false}
              isAssigned={false}
              onAccept={handleAccept}
            />
          </Grid2>
        </Box>
        <Box className="pt-24">
          {isShowAllChecked && (
            <Box>
              <Grid2 container spacing={3}>
                <Grid2 size={{ xs: 12 }}>
                  <Box className="text-align-left">
                    <CustomTypography
                      id="title-myconsults"
                      variant="h6"
                      color="textDisabled"
                    >
                      Assigned Consults&nbsp;(
                      {todaysConsultList?.assignedConsults.length ?? 0})
                    </CustomTypography>
                  </Box>
                </Grid2>

                <ConsultListRender
                  consults={todaysConsultList?.assignedConsults ?? []}
                  emptyMessage="No Assigned Consults"
                  loading={isPending || !todaysConsultList}
                  assigned={true}
                  isAssigned={false}
                />
              </Grid2>
            </Box>
          )}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        <Box>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <Box className="text-align-left flex">
                <CustomTypography
                  id="title-myconsults"
                  variant="h6"
                  color="textDisabled"
                >
                  My Past Consults&nbsp;(
                  {pastsConsultList?.myPastConsults.length ?? 0})
                </CustomTypography>
              </Box>
            </Grid2>

            <ConsultListRender
              consults={pastsConsultList?.myPastConsults ?? []}
              emptyMessage="No Past Consults"
              loading={pastsPending || !pastsConsultList}
              assigned={false}
              isAssigned={false}
              onAccept={() => handleAccept}
              pastConsult={true}
            />
          </Grid2>
        </Box>
        {isShowAllChecked && (
          <Box className="pt-24">
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12 }}>
                <Box className="text-align-left">
                  <CustomTypography
                    id="title-myconsults"
                    variant="h6"
                    color="textDisabled"
                  >
                    Other Past Consults&nbsp;(
                    {pastsConsultList?.assignedPastConsults.length ?? 0})
                  </CustomTypography>
                </Box>
              </Grid2>

              <ConsultListRender
                consults={pastsConsultList?.assignedPastConsults ?? []}
                emptyMessage="No past assigned consults"
                loading={pastsPending || !pastsConsultList}
                assigned={true}
                isAssigned={true}
                onAccept={() => handleAccept}
                pastConsult={true}
              />
            </Grid2>
          </Box>
        )}
      </CustomTabPanel>

      {alertAccept && (
        <WarningDialog
          alertAccept={alertAccept}
          onClose={() => setAlertAccept(null)}
          buttonText="Close"
        />
      )}
    </Box>
  );
};

export default MyConsults;
